import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { ArrayListService } from '../../shared/utilities/array-list.service';
import { ReflectionService } from '../../shared/utilities/reflection.service';
import { BaseInputComponent } from '../base-input/base-input.component';
import { ChipListInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-chip-list',
    templateUrl: './chip-list.component.html',
    styleUrls: ['./chip-list.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ChipListComponent extends BaseInputComponent implements OnInit {
    @Input() input: ChipListInputType;
    chips: Array<any> = [];
    inputControl: UntypedFormControl = new UntypedFormControl('');

    constructor(
        private list: ArrayListService,
        private reflect: ReflectionService,
        private questionStateService: QuestionStateService
    ) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
        if (this.input.control.value) {
            (this.input.control.value as Array<string>).forEach((v) => {
                this.chips.push(v);
            });
        }
    }

    remove(chip: any) {
        this.chips = this.list.removeIfExists(this.chips, chip);
        this.input.control.setValue(this.chips);
    }

    add($event: MatChipInputEvent) {
        if (this.reflect.isNotNullOrEmpty($event.value)) {
            this.chips = this.list.addIfNotExists(this.chips, $event.value);
            this.inputControl.setValue('');
            this.input.control.setValue(this.chips);
        }
    }
}
